module.exports = __webpack_public_path__ + "img/shipo-icon-edit-check-list.7b708904.svg";